import { post, get } from '../../../services/request';

// Volume Trend Report Data Fetch
export const fetchVolumeTrendReport = (payload) => {
    return post('ExamData/GetVolumeTrendReportsWithPagination', payload);
};


//Pivot Volume Trend By ID
export const fetchPivotVolumeTrendById = (payload) => {
    return post('ExamData/GetPivotVolumeTrendByIdWithPagination', payload);
};

export const fetchPivotVolumeTrendByIdEncore = (payload) => {
    return post('ExamData/GetPivotVolumeTrendByIdWithPagination_Encore', payload);
};

//Unread Pivot Volume Trend By ID
export const fetchUnreadPivotVolumeTrendById = (payload) => {
    return post('ExamData/GetUnreadPivotVolumeTrendPracticeByIdWithPagination', payload);
};

//Unread Pivot Volume Trend By ID Site
export const fetchUnreadPivotVolumeTrendByIdSite = (payload) => {
    return post('ExamData/GetUnreadPivotVolumeTrendSiteByIdWithPagination', payload);
};
export const fetchUnreadPivotVolumeTrendByIdSitePriority = (payload) => {
    return post('ExamData/GetUnreadPivotVolumeTrendSites_Priority_ByIdWithPagination', payload);
};

// RollOver ExamData Volume Trend
export const fetchRolloverExamDataVolumeTrend = (payload) => {
    return post('ExamData/GetRollOverExamDataVolumeTrend', payload);
};

export const fetchRolloverExamDataVolumeTrendEncore = (payload) => {
    return post('ExamData/GetRollOverExamDataVolumeTrend_Encore', payload);
};

// Delete Scheduling ForeCast Report
export const deleteSchedulingForecastReport = (id) => {
    return get(
        `ExamData/DeleteSchedulingForecastReport?VolumeTrendReportID=${id}`
    );
};

// Get Volume Trend ReportsBy ID

export const fetchVolumeTrendReportsById = (payload) => {
    return post('ExamData/GetVolumeTrendReportsByID', payload);
};
export const fetchVolumeTrendSchedulingForecastById = (payload) => {
    return post('ExamData/GetVolumeTrendSchedulingForecastByIdWithPagination', payload);
};

export const fetchVolumeTrendSchedulingForecastSiteById = (payload) => {
    return post('ExamData/GetVolumeTrendSchedulingForecastSitesByIdWithPagination', payload);
};

export const fetchVolumeTrendSchedulingForecastSitePriorityById = (payload) => {
    return post('ExamData/GetVolumeTrendSchedulingForecastSites_Priority_ByIdWithPagination', payload);
};

// Save Volumn Trend Report
export const saveVolumeTrendReport = (payload) => {
    return post('ExamData/SaveVolumeTrendReport', payload);
};

export const saveVolumeTrendReportEncore = (payload) => {
    return post('ExamData/SaveVolumeTrendReport_Encore', payload);
};

// Draft Save Volume Trend Report
export const draftSaveVolumeTrendReport = (payload) => {
    return post('ExamData/DraftVolumeTrendReport', payload);
};

// Publish Volume Trend Report
export const publishVolumeTrendReport = (payload) => {
    return post('ExamData/PublishVolumeTrendReports_Encore', payload);
};

//Export Volume Trend Report
export const exportVolumeTrendReport = (payload) => {
    return post('ExamData/GenerateVolumeTrendReport', payload);
};


// Report Note
export const fetchReportNote = (payload) => {
    return post('Common/GetReportNote', payload);
};

// Save Report Note
export const saveReportNote = (payload) => {
    return post('Common/UpdateReportNote', payload);
};

// Get Exam Data Volume Trend (for Roll Over Demand)
export const fetchExamDataVolumeTrend = (payload) => {
    return post('ExamData/GetExamDataVolumeTrend', payload);
};

// Get Volume Trend Dropdowns by Date and User
export const fetchVolumeTrendDropDowns = (payload) => {
    return post('Examdata/VolumeTrendDropDowns', payload);
};